<template lang="pug"> 
  v-row(no-gutters)
    v-col(cols=12, md=4).pt-3
      n-datepicker-range(
        :date-range='dateRange'
        @setDateRange='setDateRange'
      )
    v-col(cols=12).pt-3
      n-data-table-card-result(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      ) 
        template(#item.rightActionEffectToCard='{item}')
          | {{ item.created_at | dateFormat}}

        template(#item.note='{item}')
          | {{ item.ref_transaction_type ? item.ref_transaction_type.name : '' }}
          | {{ item.description ? item.description : '' }}
          | {{ item.ref_id ? '#'+item.ref_id : '' }} 

    loading-status(:had-data='hadData')
</template>
<script> 
import { transactions as apiTransactions } from '@/apis'

export default { 
  data: () => ({
    items : [],
    page:1,
    meta:{},
    hadData:false,
    dateRange : ['',''],
    headers:[  
      { text: 'table.transaction-type', value: 'transaction_type.name'},
      { text: 'table.actor-profile', value: 'actor_profile.username' },
      { text: 'table.subject-profile', value: 'subject_profile.username' },
      { text: 'table.credit', value: 'amount', format:'currencyAction'},
      { text: 'table.after-credit', value: 'after_amount', format:'currency' },
      { text: 'table.transaction-date', value: 'rightActionEffectToCard' },
      { text: 'table.note', value: 'note' }, 
    ],
  }), 
  methods : {
    setDateRange (value) { 
      this.dateRange = value
      if(this.dateRange[1]!==''){
        this.$ga.event('Button', 'SelectDateRange', 'CreditPage','' )
        this.load ()
      } 
    },
    async load (params = {}) {
      params = {
        page : this.page,
        transaction_type_id:5,
        start_date : this.dateRange[0],
        end_date : this.dateRange[1]
      }

      this.hadData=false 
      const [err,data,,meta] = await apiTransactions.get(params)
      this.hadData=true 
      
      if(err) { 
        this.$alert('',err,'warning')  
        return
      }

      this.meta = meta
      this.items = data 
    },
    nextpage (value) {
      this.page = value
      this.load ()
    }
  }
}
</script> 